import axios from "axios";
import { API } from "@/context/AuthContext";

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

export { API };
